/* eslint react/prop-types: off */
import React from 'react'
import { isEmpty, find, every, isNull } from 'lodash'
import Select from 'react-select'
import {
  Alert,
  Button,
  ButtonContainer,
  FormInput,
  FormInputCheckbox,
  FormInputTextArea,
  TabBar,
  TabBarTab,
  Tip
} from 'camino-react'

import Modal from 'Components/Modal'

const ConvertModal = ({
  modal,
  isSourceTheSame,
  setModal,
  errors,
  problemLinkType,
  toggleProblemStatus,
  selectedAlerts,
  assigneeQueues,
  queuesAssignees,
  handleAssignToMe,
  handleFieldValue,
  handleQueue,
  users,
  convertAlerts,
  convertButtonText,
  fields,
  ticketsForSelect,
  loadingTickets,
  getTickets,
  setTitleAndDescription,
  ownTitleAndDescription
}) => {
  const areTheSameClientsSelected = selectedAlerts.every(alert => (
    alert.client_id === selectedAlerts[0].client_id
  ))

  let usersForSelectedClient = []
  if (!isNull(selectedAlerts[0]?.client_id)) {
    usersForSelectedClient = users?.filter(user => (
      user.client_id === selectedAlerts[0]?.client_id
    ))
  }

  let usersForSelect = users?.filter(user => user.client_id === 1) // Calligo users
  if (areTheSameClientsSelected && usersForSelectedClient?.length !== 0) {
    usersForSelect = usersForSelectedClient
  }

  const clientContactOptions = usersForSelect?.map(({ name: label, id: value }) => ({ label, value }))

  return (
    <Modal title="Convert alerts to tickets" showModal={modal === 'convert'} removeModal={() => setModal(null)}>
      {fields.disabledContactNotifications && (
        <Alert type="info">
          No customer notifications will be sent out, as they have been
          disabled. These can be re-enabled under Company Information.
        </Alert>
      )}

      {!isSourceTheSame && (
        <Alert type="error" title={"You've selected alerts from different source. Not every action is available."} />
      )}
      {!isEmpty(errors) && (
        <Alert type="error">
          {errors}
        </Alert>
      )}
      <FormInput>
        <TabBar>
          <TabBarTab active={!problemLinkType} onClick={() => toggleProblemStatus(null)}>
            Create multiple tickets
          </TabBarTab>
          <TabBarTab active={problemLinkType === 'merge'} onClick={() => toggleProblemStatus('merge')}>
            Merge to existing
          </TabBarTab>
          <TabBarTab
            disabled={!isSourceTheSame || selectedAlerts?.length < 2}
            active={problemLinkType === 'create_single'}
            onClick={() => toggleProblemStatus('create_single')}
          >
            Create single ticket
          </TabBarTab>
        </TabBar>
      </FormInput>

      {!problemLinkType && (
        <>
          <button
            type="button"
            style={{ marginRight: '0.75rem', marginBottom: '0.75rem' }}
            className="link"
            onClick={() => setTitleAndDescription()}
          >
            Set ticket title and description
          </button>

          <Tip
            content="If the title and description fields are open, each converted
              ticket will have a title and description provided. Otherwise, each
              ticket will have a title and description taken from the alert."
          />
        </>
      )}

      {(problemLinkType || (!problemLinkType && ownTitleAndDescription)) && (
        <>
          <FormInput label="Ticket Title">
            <FormInputTextArea
              value={fields.title}
              onValue={e => handleFieldValue('title', e)}
            />
          </FormInput>

          <FormInput label="Ticket Description">
            <FormInputTextArea
              value={fields.description}
              onValue={e => handleFieldValue('description', e)}
            />
          </FormInput>
        </>
      )}

      <FormInput label="Ticket Contact">
        {every(selectedAlerts, alert => isNull(alert.client_id)) && (
          <em style={{ fontSize: '10px' }}>Using Calligo users as no client has been found for this alert</em>
        )}

        <Select
          value={find(clientContactOptions, ['value', fields.contactId])}
          onChange={(e) => { handleFieldValue('contactId', e) }}
          options={clientContactOptions}
        />
      </FormInput>

      <div className="-mt-6 mb-4 flex items-center">
        <FormInputCheckbox
          value={fields.disabledContactNotifications}
          onValue={value => handleFieldValue('disabledContactNotifications', value)}
        >
          <span className="mr-2">
            Disable client notifications for this ticket
          </span>
        </FormInputCheckbox>

        <Tip content="Select this checkbox if you don't want to send any email to the customer contact" />
      </div>

      <FormInput label="Queue">
        <Select
          value={fields.queueId}
          onChange={(e) => { handleQueue(e) }}
          options={fields.assignToMe ? find(assigneeQueues, ({ value: fields.assigneeId })).queues : queuesAssignees}
        />
      </FormInput>
      <FormInput label="Assignee">
        <Select
          disabled={fields.assignToMe}
          value={fields.assignToMe ? find(assigneeQueues, ({ value: fields.assigneeId })) : fields.assigneeId}
          onChange={(e) => { handleFieldValue('assigneeId', e) }}
          options={fields.queueId ? find(queuesAssignees, ({ value: fields.queueId })).assignees : ''}
        />
      </FormInput>

      <FormInput label="Assign to me">
        <FormInputCheckbox
          id="assignToMe"
          value={fields.assignToMe}
          rows={5}
          onValue={value => handleAssignToMe(value)}
        />
      </FormInput>

      { problemLinkType === 'merge' && (
        <FormInput label="Ticket">
          <Select
            value={fields.ticketId}
            onChange={(e) => { handleFieldValue('ticketId', e); console.log(e) }}
            options={ticketsForSelect}
            isLoading={loadingTickets}
            onInputChange={value => getTickets(value)}
            placeholder="Input at least 4 characters..."
          />
        </FormInput>
      ) }

      <ButtonContainer center spaced>
        <Button color="dark" outline onClick={() => setModal(null)}>
          Cancel
        </Button>
        <Button onClick={() => convertAlerts()}>
          {convertButtonText}
        </Button>
      </ButtonContainer>
    </Modal>
  )
}

export default ConvertModal
